<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-tabs pills>
                            <b-tab title="Бир йилга бир кв. метр учун энг кам ставка (Эс)">
                                <RentalRatesList :date="'Ижара тўлови ставкалари'"></RentalRatesList>
                            </b-tab>
                            <b-tab title="Ижарага бериладиган майдонларнинг умумий номи">
                                <PurposesRentingAreasList :date="'Ижарага бериладиган майдонларнинг умумий номи'"></PurposesRentingAreasList>
                            </b-tab>
                            <b-tab title="Ижарага бериладиган майдонларнинг ижарага максадлари бўйича номи">
                                <PurposesRentingAreasItemList :date="'Ижарага бериладиган майдонларнинг ижара максадлари бўйича номи'"></PurposesRentingAreasItemList>
                            </b-tab>
                            <b-tab title="Ҳудудий зоналар коэффициенти (Кз)">
                                <CoefficientRegionalZonesList :date="'Ҳудудий зоналар коэффициенти (Кз)'"></CoefficientRegionalZonesList>
                            </b-tab>
                            <b-tab title="Бинонинг фойдаланиш коэффициентлари">
                                <RealEstateEmploymentCoefficient />
                            </b-tab>
                            <b-tab title="Бинонинг коэффициентлари майдон турлари">
                                <RealEstateEmploymentCoefficientField />
                            </b-tab>
                            <b-tab title="Марказий кўчалар">
                                <CentralStreet />
                            </b-tab>
                            <b-tab title="Жисмоний шахслар учун ижара ставкаси">
                                <RentalRatesForIndividualList />
                            </b-tab>
                            <b-tab title="Ижара ставкаси илова хужжатлари(Юридик)">
                                <RRApplicationLegalList />
                            </b-tab>
                            <b-tab title="Ижара ставкаси илова хужжатлари(Жисмоний)">
                                <RRApplicationPhysicalList />
                            </b-tab>
                            <b-tab title="Ҳудудий зоналар коэффиценти (Кз) янги">
                                <CoefficientOfTerritorialZonesList />
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
    import bTab from 'bootstrap-vue/es/components/tabs/tab';
    import PurposesRentingAreasList from '@/views/config/rental_rates/PurposesRentingAreasList';
    import PurposesRentingAreasItemList from '@/views/config/rental_rates/PurposesRentingAreasItemList';
    import RentalRatesList from '@/views/config/rental_rates/RentalRatesList';
    import CoefficientRegionalZonesList from '@/views/config/rental_rates/CoefficientRegionalZonesList';
    import RealEstateEmploymentCoefficientField from '@/views/config/rental_rates/RealEstateEmploymentCoefficientFieldList'
    import RealEstateEmploymentCoefficient from '@/views/config/rental_rates/RealEstateEmploymentCoefficientList'
    import CentralStreet from '@/views/config/rental_rates/CentralStreetList'
    import RentalRatesForIndividualList from '@/views/config/rental_rates/RentalRatesForIndividualList'
    import CoefficientOfTerritorialZonesList from "@/views/config/rental_rates/CoefficientOfTerritorialZonesList";
    import RRApplicationLegalList from "@/views/config/rental_rates/RRApplicationLegalList";
    import RRApplicationPhysicalList from "@/views/config/rental_rates/RRApplicationPhysicalList";

    export default {
        name: "RentalRatesConfig",
        components: {
            CoefficientOfTerritorialZonesList,
            'b-tabs': bTabs,
            'b-tab': bTab,
            PurposesRentingAreasList,
            PurposesRentingAreasItemList,
            RentalRatesList,
            CoefficientRegionalZonesList,
            RealEstateEmploymentCoefficientField,
            RealEstateEmploymentCoefficient,
            CentralStreet,
            RentalRatesForIndividualList,
            RRApplicationPhysicalList,
            RRApplicationLegalList
        }
    }
</script>

<style scoped>

</style>